import styled, { css } from 'styled-components';
import { Breakpoints } from '../../../styled/constants';
import {
  PARALLAX_GAP_CLOSE_HIT_PADDING_MOBILE_PX,
  PARALLAX_GAP_CLOSE_ICON_MOBILE_PX,
  PARALLAX_GAP_SLOT_HEIGHT_DESKTOP_PX,
  PARALLAX_GAP_SLOT_HEIGHT_MOBILE_PX,
  PARALLAX_GAP_SLOT_RADIUS_PX
} from './constants';

export const PromoGapSlot = styled.div<{ $isHidden?: boolean }>`
  flex: 1 1 100%;
  max-width: calc(100% - 10px);
  margin: 0 0 15px 10px;
  height: ${PARALLAX_GAP_SLOT_HEIGHT_MOBILE_PX}px;
  position: relative;
  z-index: 1;
  overflow: hidden;
  overflow: clip;
  clip-path: inset(0 round ${PARALLAX_GAP_SLOT_RADIUS_PX}px);
  -webkit-clip-path: inset(0 round ${PARALLAX_GAP_SLOT_RADIUS_PX}px);
  border-radius: ${PARALLAX_GAP_SLOT_RADIUS_PX}px;
  background: transparent;
  pointer-events: none;
  visibility: ${({ $isHidden }) => ($isHidden ? 'hidden' : 'visible')};

  @media (min-width: ${Breakpoints.desktop}px) {
    height: ${PARALLAX_GAP_SLOT_HEIGHT_DESKTOP_PX}px;
    z-index: 3;
    overflow: hidden;
    clip-path: none;
    -webkit-clip-path: none;
  }
`;

export const DesktopPromoLink = styled.a`
  position: absolute;
  inset: 0;
  display: block;
  text-decoration: none;
  pointer-events: auto;
`;

export const DesktopFixedBackground = styled.div<{
  $image: string;
  $pinCrop?: boolean;
}>`
  position: absolute;
  inset: 0;
  background-image: url(${({ $image }) => JSON.stringify($image)});
  background-position: ${({ $pinCrop }) =>
    $pinCrop ? 'center top' : 'center'};
  background-repeat: no-repeat;
  background-size: ${({ $pinCrop }) => ($pinCrop ? 'cover' : 'auto')};
  background-attachment: ${({ $pinCrop }) => ($pinCrop ? 'scroll' : 'fixed')};
`;

type FixedBoxProps = {
  $top: number;
  $left: number;
  $width: number;
  $height: number;
};

const fixedBox = css<FixedBoxProps>`
  position: fixed;
  top: ${({ $top }) => $top}px;
  left: ${({ $left }) => $left}px;
  width: ${({ $width }) => $width}px;
  height: ${({ $height }) => $height}px;
  box-sizing: border-box;
  pointer-events: none;
  background-color: ${({ theme }) => theme.colors.background.primary};
`;

export const StickyStrip = styled.div<FixedBoxProps>`
  ${fixedBox}
  z-index: 50;
  overflow: hidden;
  border-radius: 12px;
`;

export const ContentCover = styled.div<FixedBoxProps>`
  ${fixedBox}
  z-index: 4;
`;

export const HiddenBannerLoader = styled.div`
  position: fixed;
  left: -10000px;
  top: -10000px;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
`;

export const MobileSlotCreative = styled.div`
  position: fixed;
  inset: 0;
  pointer-events: none;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

export const ViewportMaskCreative = styled.div<{ $pinCrop?: boolean }>`
  position: absolute;
  inset: 0;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: ${({ $pinCrop }) => ($pinCrop ? 'center top' : 'center')};
  }
`;

export const CloseButton = styled.button<{ $isPinned?: boolean }>`
  appearance: none;
  border: 0;
  margin: 0;
  width: ${PARALLAX_GAP_CLOSE_ICON_MOBILE_PX}px;
  height: ${PARALLAX_GAP_CLOSE_ICON_MOBILE_PX}px;
  padding: ${PARALLAX_GAP_CLOSE_HIT_PADDING_MOBILE_PX}px;
  box-sizing: content-box;
  flex-shrink: 0;
  cursor: pointer;
  position: absolute;
  top: calc(20px - ${PARALLAX_GAP_CLOSE_HIT_PADDING_MOBILE_PX}px);
  right: calc(15px - ${PARALLAX_GAP_CLOSE_HIT_PADDING_MOBILE_PX}px);
  z-index: 3;
  pointer-events: auto;
  background: url('/static/images/close-search-banner.svg') no-repeat center /
    contain;
  background-origin: content-box;
  background-clip: content-box;

  @media (min-width: ${Breakpoints.desktop}px) {
    width: 20px;
    height: 20px;
    padding: 0;
    box-sizing: border-box;
    background-origin: padding-box;
    background-clip: border-box;
    top: ${({ $isPinned }) => ($isPinned ? 25 : 30)}px;
    right: ${({ $isPinned }) => ($isPinned ? 15 : 30)}px;
  }
`;
